import { isProduction } from "../utils/helpers";

export const BASE_URL = isProduction()
  ? "https://api.jahuel.cl/api/"
  : "http://localhost:8081/api/";
